<div class="date-container">
    <span class="icon"><img src="assets/assignments/submissions/date.svg"/></span>
    <span class="date">{{ formattedDate }}</span>
    <span class="divider">|</span>
    <span class="icon"><edu-clock [dateTime]="this.date"></edu-clock></span>
    <span class="time">{{ formattedTime }}</span>
</div>